<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Numeric Input</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content" *ngIf="isBrowser">
  <form [formGroup]="formElement" (ngSubmit)="onSubmit()" id="form1">
    <div class="text-center mb-4">
      <h2>Reactive form :: Input </h2>
    </div>
    <p>Please enter the value in between {{minVal}} to {{maxVal}} </p>
    <maced-numeric-input inputId="input1" name="input1" label="Numeric" ariaLabel="Numeric Input"
      stepUpAriaLabel="Increase Number" stepDownAriaLabel="Decrease Number" type="number" placeholder="enter number"
      [min]="minVal" [max]="maxVal" [required]="true" formControlName="inputNumber"
      [hasError]="(formElement.controls.inputNumber.touched || submitted) && (formElement.controls.inputNumber.errors?.required || formElement.controls.inputNumber.errors?.minError || formElement.controls.inputNumber.errors?.onlyNumberError)">
      <ng-container ngProjectAs="[message]">
        <div class="c-input-group__help-text">
          This is helper text
        </div>
        <div class="c-input-group__error" role="alert"
          *ngIf="(formElement.controls.inputNumber.touched || submitted) && formElement.controls.inputNumber.errors?.required">
          This field is required
        </div>
        <div class="c-input-group__error" role="alert"
          *ngIf="(formElement.controls.inputNumber.touched || submitted) && formElement.controls.inputNumber.errors?.minError">
          This Should have minimum value :{{minVal}} and maximun:{{maxVal}}
        </div>
        <div class="c-input-group__error" role="alert"
          *ngIf="(formElement.controls.inputNumber.touched || submitted) && formElement.controls.inputNumber.errors?.onlyNumberError">
          Should accepts only number
        </div>
      </ng-container>
    </maced-numeric-input>
    <p>
      Result:- {{ formElement.value.inputNumber }}
    </p>

    <maced-numeric-input inputId="input2" name="input2" label="Numeric" ariaLabel="Numeric Input"
      stepUpAriaLabel="Increase Number" stepDownAriaLabel="Decrease Number" type="text" placeholder="enter number"
      [min]="minVal" [max]="maxVal" [required]="true" formControlName="inputNumber2"
      [hasError]="(formElement.controls.inputNumber2.touched || submitted) && (formElement.controls.inputNumber2.errors?.required || formElement.controls.inputNumber2.errors?.minError || formElement.controls.inputNumber.errors?.onlyNumberError)">
      <ng-container ngProjectAs="[message]">
        <div class="c-input-group__error" role="alert"
          *ngIf="(formElement.controls.inputNumber2.touched || submitted) && formElement.controls.inputNumber2.errors?.required">
          This field is required
        </div>
        <div class="c-input-group__error" role="alert"
          *ngIf="(formElement.controls.inputNumber2.touched || submitted) && formElement.controls.inputNumber2.errors?.minError">
          This Should have minimum value :{{minVal}} and maximun:{{maxVal}}
        </div>
        <div class="c-input-group__error" role="alert"
          *ngIf="(formElement.controls.inputNumber2.touched || submitted) && formElement.controls.inputNumber2.errors?.onlyNumberError">
          Should accepts only number
        </div>
      </ng-container>
    </maced-numeric-input>
    <p>
      Result:- {{ formElement.value.inputNumber2 }}
    </p>
<h2>Reactive form with formId</h2>
    <maced-numeric-input inputId="input4" name="input4" label="Numeric" ariaLabel="Numeric Input"
    stepUpAriaLabel="Increase Number" stepDownAriaLabel="Decrease Number" type="text" placeholder="enter number"
    [min]="minVal" [max]="maxVal" [required]="true" formControlName="formId" formID="form1"
    [hasError]="(formElement.controls.formId.touched || submitted) && (formElement.controls.formId.errors?.required || formElement.controls.formId.errors?.minError || formElement.controls.inputNumber.errors?.onlyNumberError)">
    <ng-container ngProjectAs="[message]">
      <div class="c-input-group__error" role="alert"
        *ngIf="(formElement.controls.formId.touched || submitted) && formElement.controls.formId.errors?.required">
        This field is required
      </div>
      <div class="c-input-group__error" role="alert"
        *ngIf="(formElement.controls.formId.touched || submitted) && formElement.controls.formId.errors?.minError">
        This Should have minimum value :{{minVal}} and maximun:{{maxVal}}
      </div>
      <div class="c-input-group__error" role="alert"
        *ngIf="(formElement.controls.formId.touched || submitted) && formElement.controls.formId.errors?.onlyNumberError">
        Should accepts only number
      </div>
    </ng-container>
  </maced-numeric-input>
  <p>
    Result:- {{ formElement.value.formId }}
  </p>
    <maced-button buttonId="submit1" form="form1" label="Submit" buttonType="submit"></maced-button>
  </form>

  <br>
  <br>
  <maced-numeric-input inputId="input3" name="input3" label="Disabled State Numeric Input"
    ariaLabel="Disabled State Numeric Input" stepUpAriaLabel="Increase Number" stepDownAriaLabel="Decrease Number"
    type="text" placeholder="enter number" [min]="minVal" [max]="maxVal" [disabled]="true">
  </maced-numeric-input>
</div>

<div class="content" *ngIf="!isBrowser">
  <h3>NoJs Numeric Input</h3>
  <form action="/numeric-input" method="get" id="form2">
    <maced-numeric-input inputId="noJsInput" name="noJsInput" label="No JS Numeric Input" ariaLabel="No JS Numeric Input"
      stepUpAriaLabel="Increase Number" stepDownAriaLabel="Decrease Number" type="number" placeholder="enter number" formID="form2"
      [min]="minVal" [max]="maxVal" [(ngModel)]="inputNgModelNojs">
    </maced-numeric-input>
    <maced-button buttonId="submit2" form="form2" label="Submit" buttonType="submit"></maced-button>
  </form>
  <div>
    <h4>Result</h4>
    <div>
      Input value:-&nbsp;
      {{ inputNgModelNojs }}
    </div>
  </div>
</div>